/** Refactor of AnalyticsView to use pinia store instead.
 *
 * Currently only contains content gap state and actions.
 */
import api from "@/api";
import { useUserStore } from "@/stores/user";
import { useToast } from "vue-toastification";
// TODO: One day, someone will refactor the entire analytics to use store.
export const useAnalyticsStore = defineStore("analytics", {
  state: () => ({
    /** @type {KnowledgeGap[]} */
    contentGaps: [],
  }),
  actions: {
    /** Refresh all analytics states. */
    async refreshAll() {
      await Promise.all([this.refreshContentGaps()]);
    },

    /***************
     * Content Gap *
     ***************/
    /** Refresh content gap state. */
    async refreshContentGaps() {
      const userStore = useUserStore();
      const toast = useToast();

      try {
        const resp = await api.analytics.fetchAIAnalytics({
          organization_id: userStore.authUserOrganizationId,
          can_see_admin: userStore.canSeeAdmin,
        });
        this.contentGaps = resp.data ?? [];
      } catch (err) {
        this.contentGaps = [];
        console.warning("error fetching content gaps", err);
        toast.warning("Failed to fetch content recommendations!");
      }
    },

    async changeSubGapStatus(gapId, status) {
      const toast = useToast();

      try {
        const data = await api.analytics.changeSubGapStatus(gapId, status);
        let newSubGap = data.sub_gaps.find((gap) => gap.id === gapId);

        for (const mainGap of this.contentGaps ?? []) {
          const curSubGap = mainGap.sub_gaps.find((gap) => gap.id === gapId);
          if (curSubGap) {
            Object.assign(curSubGap, newSubGap);
            // TODO: Need better way to merge without unnecessary assignment.
            mainGap.resolved = data.resolved;
            mainGap.resolved_at = data.resolved_at;
            return true;
          }
        }
        // TODO: Actually at this point data is out-of-sync, should escalate to reload.
        console.warning("Couldn't find existing subgap to update?");
        return true;
      } catch (err) {
        console.error(err);
        toast.error("Failed to update status!");
        return false;
      }
    },
  },
});

/** Typedefs:
 * @typedef {"ACTIONABLE" | "ASSIGNED" | "IGNORED" | "RESOLVED"} ContentGapStatusEnum
 *
 * @typedef InteractionExample
 * @property {string} id
 * @property {string} interaction_id
 * @property {string} query
 * @property {boolean} ignore
 * @property {boolean} resolved
 * @property {string | null} resolved_at
 * @property {string} year_month
 * @property {string} resolved_year_month
 * @property {string} created_at
 *
 * @typedef SubGap
 * @property {string} id
 * @property {string} sub_theme
 * @property {string} solution
 * @property {InteractionExample[]} examples
 * @property {ContentGapStatusEnum} status
 * @property {string | null} resolved_at
 * @property {string} year_month
 * @property {string} resolved_year_month
 * @property {string} created_at
 *
 * @typedef KnowledgeGap
 * @property {string} id
 * @property {string} main_theme
 * @property {string} solution
 * @property {SubGap[]} sub_gaps
 * @property {boolean} ignore
 * @property {boolean} resolved
 * @property {string | null} resolved_at
 * @property {string} department_id
 * @property {string} department_code
 * @property {string} department_name
 * @property {string} organization_id
 * @property {string} organization_code
 * @property {string} year_month
 * @property {string} resolved_year_month
 * @property {string} created_at
 * @property {string} updated_at
 */
